// v-reveal: fades an element up into place the first time it scrolls into
// view. Pass a number to delay it (ms) for staggering, or false to disable.
const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

let observer = null;

function getObserver() {
  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px" }
    );
  }
  return observer;
}

export default {
  mounted(el, binding) {
    if (binding.value === false || reducedMotion.matches) return;
    if (!("IntersectionObserver" in window)) return;

    if (typeof binding.value === "number") {
      el.style.setProperty("--reveal-delay", binding.value + "ms");
    }
    el.classList.add("reveal");
    getObserver().observe(el);
  },
  unmounted(el) {
    if (observer) observer.unobserve(el);
  },
};
